<template>
  <div style="height: 100%" class="mb-3">
    <template>
      <div v-if="currentImages.length > 0">
        <template v-for="(file, index) in currentImages">
          <div :key="`upload-file-${index + 1}`">
            <v-alert dense text color="green darken-2">
              <v-row align="center" no-gutters>
                <v-col class="text-center font-weight-bold"
                  >เอกสารเพิ่มเติม {{ index + 1 }}</v-col
                >
                <v-col cols="auto">
                  <v-btn icon @click.stop="deleteFile(file)" color="error">
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
              <!-- <v-layout justify-space-between align-center>
                <div>เอกสารเพิ่มเติม {{ index + 1 }}</div>
                <div>
                  <v-btn icon @click.stop="deleteFile(file)" color="error">
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </div>
              </v-layout> -->
            </v-alert>
          </div>
        </template>
      </div>

      <!-- <template v-if="currentImages.length < maxUploadFile">
        <div
          style="
          border: 1px solid grey;
          border-radius: 0px;
          position: relative;
          background-color: rgb(240 240 240);
          position: relative;
          height: 60px
        "
          :style="{
            cursor: currentImages.length === maxUploadFile ? 'auto' : 'pointer',
            border: `1px solid ${errors.length ? 'red' : 'grey'}`,
          }"
          @click="showUploadButton = true"
        >
          <v-layout
            justify-center
            align-center
            fill-height
            class="font-weight-bold"
            style="font-size: 19px"
          >
            <v-icon>mdi-plus</v-icon>
            <span>เพิ่มเติมเอกสาร</span>
          </v-layout>
        </div>
      </template> -->

      <template v-if="currentImages.length < maxUploadFile">
        <div
          style="
            border: 1px solid grey;
            border-radius: 0px;
            position: relative;
            background-color: rgb(240 240 240);
            position: relative;
            height: 90px;
          "
          :style="{
            cursor: currentImages.length === maxUploadFile ? 'auto' : 'pointer',
            border: `1px solid ${errors.length ? 'red' : 'grey'}`,
          }"
          @click="onClickUploadFile()"
          class="mt-6"
        >
          <div
            class="pa-3"
            style="
              height: 100%;
              text-align: center;
              display: flex;
              justify-content: center;
              align-items: center;
            "
          >
            <template v-if="loading">
              <div
                style="position: absolute; top: 0; left: 0; right: 0; bottom: 0"
              >
                <v-layout justify-center align-center style="height: 100%">
                  <v-progress-circular
                    indeterminate
                    color="primary"
                  ></v-progress-circular>
                </v-layout>
              </div>
            </template>
            <template v-else>
              <div v-if="currentImages.length === maxUploadFile">
                <div
                  class="font-weight-bold"
                  style="font-size: 19px; color: green"
                >
                  <slot>Upload</slot>
                </div>
                <div>
                  <v-icon color="green">mdi-check-circle-outline</v-icon>
                </div>
              </div>
              <div v-else>
                <div class="font-weight-bold" style="font-size: 19px">
                  <slot>Upload</slot>
                </div>
                <div>
                  <v-icon>mdi-upload</v-icon>
                </div>
              </div>
            </template>
          </div>
        </div>
      </template>

      <div style="font-size: 14px" class="mt-1">
        (อัปโหลดไฟล์เพิ่มเติมได้สูงสุด {{ maxUploadFile }} ไฟล์, ขนาดไฟล์ไม่เกิน
        3.5 MB, เฉพาะไฟล์นามสกุล .jpg .png หรือ .pdf เท่านั้น)
      </div>
    </template>

    <ValidationObserver ref="observer" v-slot="{}" tag="form">
      <ValidationProvider
        :name="'profile'"
        :rules="'image|size:5120'"
        v-slot="{}"
      >
        <input
          type="file"
          accept="application/pdf, .png, .jpg, .jpeg, .pdf;capture=camera"
          v-show="false"
          ref="inputUpload"
          class="form-control-file pt-2"
          name="photoUpload"
          id="photoUploadInput"
          data-vv-as="File"
          :key="`upload_${uploadtimestamp}`"
          @change="onFileChange($event)"
          style="
            overflow: hidden;
            position: fixed;
            width: 1px;
            height: 1px;
            z-index: -1;
            opacity: 0;
          "
        />
      </ValidationProvider>
    </ValidationObserver>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import { ValidationProvider, ValidationObserver } from "vee-validate";

export default {
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    height: {
      default: 200,
      type: Number,
    },
    maxwidth: {
      default: 500,
      type: Number,
    },
    maxheight: {
      default: 500,
      type: Number,
    },
    errors: {
      default() {
        return [];
      },
      type: Array,
    },
    background: {
      // default: require("../assets/profileplaceholder.png"),
    },
    isReturnUrl: {
      type: Boolean,
      default: false,
    },
    maxUploadFile: {
      type: Number,
      default: 1,
    },
  },
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  data: function () {
    return {
      filename: "",
      showUpload: false,
      currentImages: this.value,
      isAlert: false,
      loading: false,
      uploadtimestamp: moment().format("x"),
      showUploadButton: false,
    };
  },
  methods: {
    deleteFile(file) {
      const vm = this;
      const tempCurrentFiles = vm.currentImages;
      const CurrentFiles = tempCurrentFiles.filter((item) => item !== file);
      vm.currentImages = CurrentFiles;
      vm.$emit("input", vm.currentImages);
    },
    onClickUploadFile() {
      const vm = this;
      if (vm.currentImages.length === vm.maxUploadFile) {
        return false;
      }

      vm.uploadtimestamp = moment().format("x");
      vm.$nextTick(() => {
        vm.$refs.inputUpload.click();
      });
    },
    onClickUploadBtn() {
      document.getElementById("photoUploadInput").click();
    },
    fileResize: function (file) {
      return new Promise((resolve) => {
        const vm = this;
        let reader = new FileReader();
        reader.onloadend = function () {
          let tempImg = new Image();
          tempImg.src = reader.result;
          tempImg.onload = function () {
            const MAX_WIDTH = vm.maxwidth;
            const MAX_HEIGHT = vm.maxheight;
            let tempW = tempImg.width;
            let tempH = tempImg.height;
            if (tempW > tempH) {
              if (tempW > MAX_WIDTH) {
                tempH *= MAX_WIDTH / tempW;
                tempW = MAX_WIDTH;
              }
            } else {
              if (tempH > MAX_HEIGHT) {
                tempW *= MAX_HEIGHT / tempH;
                tempH = MAX_HEIGHT;
              }
            }

            let canvas = document.createElement("canvas");
            canvas.width = tempW;
            canvas.height = tempH;
            let ctx = canvas.getContext("2d");
            ctx.drawImage(this, 0, 0, tempW, tempH);
            const dataURL = canvas.toDataURL("image/jpeg");
            const data = "image=" + dataURL;
            let obj = vm.dataURItoBlob(data);
            obj.name = file.name;

            resolve(obj);
          };
        };
        reader.readAsDataURL(file);
      });
    },
    dataURItoBlob: function (dataURI) {
      // convert base64/URLEncoded data component to raw binary data held in a string
      var byteString;
      if (dataURI.split(",")[0].indexOf("base64") >= 0)
        byteString = atob(dataURI.split(",")[1]);
      else byteString = unescape(dataURI.split(",")[1]);

      // separate out the mime component
      var mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];

      // write the bytes of the string to a typed array
      var ia = new Uint8Array(byteString.length);
      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }

      return new Blob([ia], { type: mimeString });
    },
    onFileChange: async function (event) {
      this.isAlert = false;
      this.$emit("startImgloading");
      let vm = this;
      var isValid = await this.$refs.observer.validate();

      if (!isValid) {
        vm.uploadtimestamp = moment().format("x");
        return false;
      }
      let files = event.target.files || event.dataTransfer.files;

      const maxFileSize = 3.5; //3.5 MB
      const fileSize = files[0].size;
      if (fileSize > maxFileSize * 1000000) {
        // const fileSizeInMb = +(fileSize / 1000000).toFixed(2);
        this.$swal.fire({
          icon: "error",
          confirmButtonColor: "#c5281d",
          title: "ขนาดไฟล์ใหญ่เกินไป",
          text: "ไฟล์เอกสารต้องมีขนาดไม่เกิน 3.5 MB",
        });
        return false;
      }

      var isAllImage = true;
      // for (var i = 0; i < files.length; i++) {
      //   if (!files[i].type.includes("image")) {
      //     isAllImage = false;
      //     break;
      //   }
      // }
      if (isAllImage) {
        if (!files.length) {
          vm.uploadtimestamp = moment().format("x");
          return;
        }
        var obj = files[0];
        vm.filename = obj.name;
        vm.createImage(obj);
        event.target.value = "";
      }
    },
    createImage(file) {
      // let reader = new FileReader();
      const vm = this;
      vm.upload(file);
    },
    upload(file) {
      const vm = this;
      let data = {
        name: file.name,
        type: file.type,
        file: file,
      };
      vm.loading = true;
      var reader = new FileReader();
      reader.onload = function (evt) {
        if (evt.target.result) {
          vm.uploadfile({
            ...data,
            file: evt.target.result.replace(`data:${data.type};base64,`, ""),
          });
        }
      };
      reader.readAsDataURL(data.file);
    },
    uploadfile: function (data) {
      const vm = this;
      const formData = new FormData();

      formData.append("file", data.file);
      formData.append("type", data.type);
      axios.defaults.headers.common = {
        AUTHORIZATION: "Bearer xxxx xxx",
        "x-api-key": this.$store.state.serverApiKey,
      };

      const url = `${vm.$store.state.serverUrl}uploadfile?file-name=${data.name}&file-type=${data.type}`;
      axios
        .post(url, formData, {
          maxContentLength: 10000000,
          maxBodyLength: 10000000,
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          if (response.data.responsecode == 200) {
            var key;

            if (vm.isReturnUrl) {
              key = response.data.data.Location;
            } else {
              if (response.data.data.Key) {
                key = response.data.data.Key;
              } else {
                key = response.data.data.key;
              }
            }

            const tempCurrentFiles = vm.currentImages;

            const responseData = {
              filename: data.name,
              encoding: "base64",
              content: data.file,
            };

            tempCurrentFiles.push(responseData);
            vm.currentImages = tempCurrentFiles;
            vm.loading = false;
            vm.uploadtimestamp = moment().format("x");

            vm.$emit("input", tempCurrentFiles);
            vm.showUploadButton = false;
          } else {
            alert("Could not upload file.");
          }
        });
      // let signedRequest = data;
      // const formData = new FormData();
      // formData.append("acl", "public-read");

      // formData.append("file", data.file);
      // formData.append("type", data.type);

      // const xhr = new XMLHttpRequest();
      // xhr.open(
      //   "POST",
      //   `https://generaliapi.herokuapp.com/uploadfile_zwiz?file-name=${data.name}&file-type=${data.type}`,
      //   true
      // );
      // xhr.setRequestHeader("Access-Control-Allow-Origin", "*");
      // xhr.send(formData);
      // xhr.onload = function () {
      //   if (xhr.readyState === 4) {
      //     if (xhr.status === 200 || xhr.status === 204) {
      //       callback();
      //     } else {
      //       alert("Could not upload file.");
      //     }
      //   }
      // };
    },
  },
  watch: {
    value: function (newVal) {
      this.currentImages = newVal;
    },
  },
};
</script>
